import React from 'react';
import Table from 'react-bootstrap/Table';
import { FaPencilAlt, FaTrash } from 'react-icons/fa';
import { reactLocalStorage } from 'reactjs-localstorage';

import DashboardAPI from '../../../api/DashboardAPI';
import ReportAPI from '../../../api/ReportAPI';
import DashleadAPI from '../../../api/DashleadAPI';
import Util from '../../../util/Util';
import Const from '../../../util/Constants';
import Display from '../../../util/Display';
import ApiUiController from '../../../controller/ApiUiController';
import DashboardPopup from './DashboardPopup';
import { Badge } from 'react-bootstrap';

class DashboardList extends React.Component {

  constructor(props) {
    super(props);
    this.dashes = [];
    this.state = { popup: false, inApiCall: true };
    this.dashes = [];
    this.reports = [];
    this.dashleads = [];

    const model = reactLocalStorage.getObject(Const.Model).dashboard;
    this.List = Util.isAllow(model.permission, Const.PermView);
    this.Add = Util.isAllow(model.permission, Const.PermAdd);
    this.Update = Util.isAllow(model.permission, Const.PermUpdate);
    this.Delete = Util.isAllow(model.permission, Const.PermDelete);
  }

  componentDidMount() {
    if (this.List) {
      ReportAPI.list(this.onReportReceived, this.onFail);
    }
  }
  onFail = (res) => {
    const message = res.message ? JSON.stringify(res.message) : 'Something went wrong';
    Util.showError(message);
    this.setState({ ...this.state, inApiCall: false });
  };
  onReportReceived = reports => {
    this.reports = reports.map(report => { return { label: report.name, value: report.id }; });
    DashleadAPI.list(this.onDashleadReceived, this.onFail);
  };
  onDashleadReceived = dashleads => {
    this.dashleads = dashleads.map(report => { return { label: report.name, value: report.id }; });
    DashboardAPI.list(this.onReceived, this.onFail);
  };
  onReceived = dashes => {
    this.dashes = dashes;
    this.setState({ ...this.state, inApiCall: false });
  };

  confirmDelete = index => {
    Util.confirmAlert('Delete', `Are you sure you want to delete to`
      + ` ${this.dashes[index].name}`, 'Delete', 'No', () => {
        this.setState({ ...this.state, inApiCall: true });
        DashboardAPI.delete(this.dashes[index].id, this.onDelete, this.onFail);
      });
  };
  onDelete = () => {
    Util.showNotification('Successful', 'Dashboard Deleted successfully', 'success');
    DashboardAPI.list(this.onReceived, this.onFail);
  };

  onShow = i => {
    if (i === -1) this.dash = null;
    else this.dash = { ...this.dashes[i] };
    this.setState({ ...this.state, popup: true });
  };
  onHide = () => this.setState({ ...this.state, popup: false });

  save = dashboard => {
    this.setState({ ...this.state, popup: false });
    DashboardAPI.save(dashboard, this.onSaved, this.onFail);
  };
  onSaved = () => {
    Util.showNotification('Successful', 'Dashboard saved successfully', 'success');
    DashboardAPI.list(this.onReceived, this.onFail);
  };

  render() {
    if (!this.List) return null;
    const dashesUI = this.dashes.map((dashe, _i) => (
      <tr key={`dashe_${_i + 1}`}>
        <td>{_i + 1}</td>
        <td>{dashe.name}</td>
        <td>{Display.ModelLabelValue('user', dashe.created_by)}</td>
        <td>{Util.serverStringToDisplayDateTime(dashe.created_date)}</td>
        <td>{Display.ModelLabelValue('user', dashe.updated_by)}</td>
        <td>{Util.serverStringToDisplayDateTime(dashe.updated_date)}</td>
        <td>
          {this.Update
            ?
            <Badge variant="warning" size='sm' onClick={() => this.onShow(_i)} className='m-1 p-2 text-white' > <FaPencilAlt color='#ffffff' /> Edit</Badge>
            : null
          }
          {dashe.status !== Const.AlwaysActive && this.Delete
            ?
            <Badge variant="danger" size='sm' onClick={() => this.confirmDelete(_i)} className='m-1 p-2 text-white' > <FaTrash color='#ffffff' /> Delete</Badge>
            : null
          }
        </td>
      </tr>
    ));

    return (
      <div className="sectionlist pt-3">
        <div className="container-fluid">
          <DashboardPopup popup={this.state.popup} onHide={this.onHide}
            reports={this.reports} dashleads={this.dashleads} dashboard={this.dash} save={this.save} />
          <div className="row">
            <div className="col-md-6 pb-3">
              <h3>Dashboard</h3>
            </div>
            {this.Add ?
              <div className="col-md-6 text-right pb-3">
                <span onClick={() => this.onShow(-1)} className="buttons success">Add Dashboard</span>
              </div>
              : null
            }

            <div className="col-md-12">
              <Table striped bordered hover>
                <thead>
                  <tr>
                    <th>No</th>
                    <th>Name</th>
                    <th>Created By</th>
                    <th>Created Date</th>
                    <th>Updated By</th>
                    <th>Updated Date</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <ApiUiController inApiCall={this.props.inApiCall} >
                    {dashesUI}
                  </ApiUiController>
                </tbody>
              </Table>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default DashboardList;
